import { React, useState, useEffect } from "react";
import history from "../../routes/history";
import contractjobIcon from "../../assets/img/contract_job.png";
import perdiem from "../../assets/img/perdiem.svg";
import permanentjobIcon from "../../assets/img/permanent_job.png";
import "./PostGig.css";
import { Row, Col, Button } from "antd";
import { useLocation } from "react-router-dom";
import { getCompanyProfileDetails } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import FeatureGate from "../FeatureGate/FeatureGate";
import Loader from "../../components/Loading/Loader";
import { isHC, setCookie } from "../../shared/helpers";
import { CONTRACT_JOB, PER_DIEM_JOB, PERMANENT_JOB } from "../../shared/constant/JobConstants";
import { canUseSubscriptionFeatures } from "../../shared/billing";

export default function PostGig(props) {
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures();
  const location = useLocation();
  const dispatch = useDispatch();
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const creditsBalanceLoaded = useSelector((state) => state.plansReducer?.creditsBalanceLoaded);
  const [later, setLater] = useState(false);

  useEffect(() => {
    if (location.state) {
      setLater(true);
    }
  }, [location.state]);
  if (subscriptionFeaturesEnabled && !creditsBalanceLoaded) return <Loader />;
  if (subscriptionFeaturesEnabled && creditsBalance?.data?.status === 'expired') return (
    <FeatureGate
      featureName="Post a Job"
      iconType="candidate"
      description="Your free trial has ended. Choose a plan to continue posting jobs and finding the right talent."
      bottomText="Post a Job is a paid feature and was given to you for free during your trial period."
    />
  );

  return (
    <div className="PostGig-resp">
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        <Col xs={24} sm={24} lg={11} xl={11} className={"PostGig-Col"}>
          <div className="PostGig-Page PostGig-Page-mobile">
            <div>
              <div className="PostGig-Header">Post a job</div>
              <div className="PostGig-desc">
                {" "}
                Post an open job and skills you’re looking for to get matched
                with the best candidates for the job.
              </div>
            </div>

            <div className="PostGig-select">Choose the job type</div>

            <Row className="PostGig-chooseJob" justify={'space-around'} wrap="nowrap" gutter={[16, 16]}>
              <Col
              flex={1}
                className="Contract-job"
                onClick={() => {
                  history.push({
                    pathname: location?.state?.fromSignUp
                      ? "/contract-gig"
                      : "/postajob/choosetemplate",
                    state: {
                      Title: "",
                      FacilityName: "",
                      Skills: "",
                      Industries: "",
                      GigDuration: "",
                      Location: "",
                      Experience: "",
                      JobOrderTypeName: CONTRACT_JOB,
                    },
                  });
                  dispatch(getCompanyProfileDetails());
                  setCookie("finishProfile", "true");
                }}
              >
                <div className="PostGig-contractJob">
                  <img
                    src={contractjobIcon}
                    alt="contractjobIcon"
                    className="PostGig-jobIcon"
                  />
                  <div className="PostGig-jobDivider"></div>
                  <div className="PostGig-jobText">Contract</div>
                </div>
              </Col>
              <Col
              flex={1}
                className="Permanent-job"
                onClick={() => {
                  history.push({
                    pathname: location?.state?.fromSignUp
                      ? "/per-gig"
                      : "/postajob/choosetemplate",
                    state: {
                      Title: "",
                      FacilityName: "",
                      Skills: "",
                      Industries: "",
                      GigDuration: "",
                      Location: "",
                      Experience: "",
                      PermanentJob: true,
                      JobOrderTypeName: PERMANENT_JOB,
                    },
                  });
                  dispatch(getCompanyProfileDetails());
                  setCookie("finishProfile", "true");
                }}
              >
                <div className="PostGig-permanentJob">
                  <img
                    src={permanentjobIcon}
                    alt="permanentjobIcon"
                    className="PostGig-jobIcon"
                  />
                  <div className="PostGig-jobDivider"></div>
                  <div className="PostGig-jobText">Permanent</div>
                </div>
              </Col>
              {isHC() && <Col
                flex={1}
                className="Permanent-job"
                onClick={() => {
                  history.push({
                    pathname: location?.state?.fromSignUp
                      ? "/contract-gig"
                      : "/postajob/choosetemplate",
                    state: {
                      Title: "",
                      FacilityName: "",
                      Skills: "",
                      Industries: "",
                      GigDuration: "",
                      Location: "",
                      Experience: "",
                      PermanentJob: false,
                      JobOrderTypeName: PER_DIEM_JOB,
                    },
                  });
                  dispatch(getCompanyProfileDetails());
                  setCookie("finishProfile", "true");
                }}
              >
                <div className="PostGig-permanentJob">
                  <img
                    src={perdiem}
                    alt="permanentjobIcon"
                    className="PostGig-jobIcon"
                  />
                  <div className="PostGig-jobDivider"></div>
                  <div className="PostGig-jobText">Per Diem
                  </div>
                </div>
              </Col>}
            </Row>
            {later && (
              <Button
                className="Later-btn"
                onClick={() => {
                  history.push({
                    pathname: "/allset",
                    state: "allset",
                  });
                  dispatch(getCompanyProfileDetails());
                }}
              >
                Skip, I’ll post a job later
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}
